<script>
  import Login from './pages/login.svelte';
  import Main from './pages/main.svelte';
  import {me} from './modules/api-client';
  import {getSession, removeSession, setSession} from "./modules/session";

  import {onMount} from 'svelte';

  function clearSession() {
    removeSession();
    location.reload();
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('jwt')) setSession(urlParams.get('jwt'));

  const session = getSession();
  let logged = !!session;
  if (session) {
    me().then(user => {
      if (user.userId) logged = true;
      else {
        clearSession();
        console.error(`Invalid user: ${JSON.stringify(user)}`)
      }
    }).catch((e) => {
      console.error(e);
      clearSession();
    });
  } else if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }

  async function addScript(script) {
    const scriptElement = document.createElement('script');
    scriptElement.src = script;
    document.body.appendChild(scriptElement);
    return new Promise(resolve => {
      scriptElement.addEventListener('load', function () {
        resolve();
      });
    });
  }

  onMount(async () => {
    await addScript('/theme/vendor/jquery/jquery.min.js');
    await addScript('/theme/vendor/bootstrap/js/bootstrap.bundle.min.js');
    await addScript('/theme/vendor/jquery-easing/jquery.easing.min.js');
    await addScript('/theme/js/sb-admin-2.min.js');
    await addScript('/theme/vendor/chart.js/Chart.js');
  });
</script>

{#if logged}
    <Main/>
{:else}
    <Login/>
{/if}

<style>
    @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css");
    @import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css");
</style>
